export function ERPHero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Ethos | ERP
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          A robust, open-source ERP system that brings together all core
          business functions into one unified platform. It includes essential
          modules such as Accounting, Inventory, Sales, Purchase, Human
          Resources, Payroll, CRM, Manufacturing, Projects, and Asset
          Management. Each module is tightly integrated, ensuring seamless data
          flow and eliminating the need for duplicate entries. It also supports
          integration with third-party systems through RESTful APIs, webhooks,
          and custom apps, making it highly adaptable to various business
          environments. With its modular architecture, businesses can start with
          the basics and scale by activating only the features they need,
          enabling efficient and transparent operations across departments.
        </p>
      </div>
      <div className="flex-1">
        <img
          src="/images/erp/erpmodules.png"
          alt="illustration"
          className="w-86 mx-auto" 
        />
      </div>
    </section>
  );
}
